import React from 'react';
import PropTypes from 'prop-types';

import { Analytics, logger } from 'packages';
import { ApplicationErrorBoundary } from 'components';
import DropDownMenuHamburger from './dropdown-menu-burger';
import Overlay from 'components/modals/overlay';
import DropdownMenuContent from './dropdown-menu-content';

import './dropdown-menu.scss';

class DropdownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: this.props.defaultExpanded
        };
    }

    trackAnalytics = action => {
        const { initData } = this.props;

        const pageName = (initData && initData.pageName) || 'undefined';

        try {
            Analytics.trackEvent({
                category: 'Header',
                action: action,
                label: `page-${pageName}`
            });
        } catch (error) {
            logger(error);
        }
    };

    onClick = () => {
        const { expanded } = this.state;

        if (!expanded) {
            this.trackAnalytics('Burger - open');
        } else {
            this.trackAnalytics('Burger - close');
        }

        this.setState({
            expanded: !expanded
        });
    };

    render() {
        const {
            cssClass,
            initData,
            formattedCartItems,
            threadsUnread,
            dispatch,
            preferredCurrency,
            currencies
        } = this.props;
        const { expanded } = this.state;

        const dropdownBodyId = 'site-dropdown__body';

        return (
            <ApplicationErrorBoundary>
                <nav className={cssClass || ''} role="navigation">
                    <DropDownMenuHamburger
                        active={expanded}
                        onClick={this.onClick}
                        cssClass="site-dropdown__hamburger"
                        notify={formattedCartItems + threadsUnread}
                    />
                    {expanded && (
                        <Overlay
                            scrollBodyCssId={dropdownBodyId}
                            show={expanded}
                            top="4.5rem"
                            zIndex={2}
                            closeModalCallback={this.onClick}
                        />
                    )}
                    {expanded && (
                        <div id={dropdownBodyId} className="site-dropdown">
                            <ul className="my-0">
                                <DropdownMenuContent
                                    initData={initData}
                                    formattedCartItems={formattedCartItems}
                                    threadsUnread={threadsUnread}
                                    dispatch={dispatch}
                                    preferredCurrency={preferredCurrency}
                                    currencies={currencies}
                                />
                            </ul>
                        </div>
                    )}
                </nav>
            </ApplicationErrorBoundary>
        );
    }
}

DropdownMenu.defaultProps = {
    defaultExpanded: false
};

DropdownMenu.propTypes = {
    cssClass: PropTypes.string,
    defaultExpanded: PropTypes.bool
};

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/dropdown-menu.jsx